import { render, staticRenderFns } from "./leadStatus.vue?vue&type=template&id=bf9053ca"
import script from "./leadStatus.vue?vue&type=script&lang=js"
export * from "./leadStatus.vue?vue&type=script&lang=js"
import style0 from "./leadStatus.vue?vue&type=style&index=0&id=bf9053ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports